/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class AppEngineLifecycleService extends __BaseService {
  static readonly AppEngineLifecycleWarmupPath = '/_ah/warmup';
  static readonly AppEngineLifecycleStartPath = '/_ah/start';
  static readonly AppEngineLifecycleStopPath = '/_ah/stop';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  AppEngineLifecycleWarmupResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/_ah/warmup`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  AppEngineLifecycleWarmup(): __Observable<null> {
    return this.AppEngineLifecycleWarmupResponse().pipe(
      __map(_r => _r.body as null)
    );
  }
  AppEngineLifecycleStartResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/_ah/start`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  AppEngineLifecycleStart(): __Observable<null> {
    return this.AppEngineLifecycleStartResponse().pipe(
      __map(_r => _r.body as null)
    );
  }
  AppEngineLifecycleStopResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/_ah/stop`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  AppEngineLifecycleStop(): __Observable<null> {
    return this.AppEngineLifecycleStopResponse().pipe(
      __map(_r => _r.body as null)
    );
  }
}

module AppEngineLifecycleService {
}

export { AppEngineLifecycleService }
